<template>
  <div
    :class="{
      'no-wrap': dense && tiny,
      'q-col-gutter-sm': dense && tiny,
      'q-col-gutter-md': !dense || !tiny
    }"
    class="row"
  >
    <span>
      <interval-timer
        v-if="hasDataObject"
        ref="timer"

        v-model="data.currentInterval"
        :interval-time="sessionProgram.program.interval"
        :duration="data.duration"
        :timer-interval-pause="sessionProgram.program.timerIntervalPause"

        :paused="data.isTimerPaused"
        :duration-offset="timerOffsetTimestamp"

        :session-program="sessionProgram.id"

        :session-paused="sessionPaused"
        :session-duration-offset="sessionDurationOffset"

        :disable="disable"
        :dense="dense"
        :tiny="tiny"
        :warning="intervalWarning"
        :warning-sound="intervalWarningSound"
        :ios-audio="iosAudio"
        :mute-audio="muteAudio"

        class="bg-primary-light full-height"

        @update:model-value="onRecordIntervalTimer"
        @start="onResumeIntervalTimer"
        @pause="onPauseIntervalTimer"
        @update="onUpdateIntervalTimer"
      />
    </span>
    <span
      v-for="target in sortedTargets"
      :key="target.id"
    >
      <esdm-data
        ref="targets"
        :session-program="sessionProgram"
        :target="target"
        :data="data"
        :active-prompt-levels="activePromptLevels"
        :dense="dense"
        :tiny="tiny"
        :disable="disable"
        :workflow-statuses="workflowStatuses"
        @record="onRecord"
        @record-program-data="onRecordProgramData"
      />
    </span>
  </div>
</template>
<script>

import EsdmData from 'components/Programs/DataCollection/EsdmData';
import IntervalTimer from 'components/Programs/DataCollection/IntervalTimer';
import { Timestamp } from 'firebase/firestore';
import { chain, get, isEmpty, isObject } from 'lodash';
import { mapState } from 'pinia';
import DataCollectionProgram from 'src/mixins/DataCollectionProgram';
import { sessions } from 'src/store/sessions';

export default {
  name: 'EsdmProgram',

  components: {
    IntervalTimer,
    EsdmData,
  },

  mixins: [DataCollectionProgram],

  emits: ['record-program-data'],

  computed: {
    ...mapState(sessions, ['currentVideoCallSession']),

    // Don't play sounds if we are in a video call - it will interfere with the call
    muteAudio() {
      return !!this.currentVideoCallSession;
    },

    hasDataObject() {
      return isObject(this.data);
    },

    timerOffsetTimestamp() {
      const timerOffsetTimestamp = get(this.data, 'timerOffsetTimestamp');
      if (chain(timerOffsetTimestamp).get('toDate').isFunction().value()) {
        return timerOffsetTimestamp.toDate();
      }
      return null;
    }, // timerOffsetTimestamp()

    intervalWarning() {
      if (!get(this.sessionProgram, ['program', 'timerWarning'], false)) {
        return null;
      }
      return get(this.sessionProgram, ['program', 'timerWarningSeconds'], 0);
    }, // intervalWarning()

    intervalWarningSound() {
      if (!get(this.sessionProgram, ['program', 'timerWarning'], false)) {
        return '';
      }
      return get(this.sessionProgram, ['program', 'timerWarningSound'], '');
    }, // intervalWarningSound()

  },

  methods: {

    finishSession() {
      const finalData = chain(this.$refs)
        .get('targets')
        .map((targetRef) => {
          if (chain(targetRef).get('finishSession').isFunction().value()) {
            return targetRef.finishSession();
          }
          return null;
        })
        .flatten()
        .compact()
        .value();

      if (chain(this.$refs).get(['timer', 'finishSession']).isFunction().value()) {
        this.$refs.timer.finishSession();
      }
      if (!isEmpty(finalData)) {
        return { finalData };
      }
    }, // finishSession()

    onRecordIntervalTimer(currentInterval) {
      if (this.disable) {
        return;
      }

      const dataObj = {
        currentInterval,
        duration: 0,
        timerOffsetTimestamp: Timestamp.now(),
        isTimerPaused: false,
      };
      this.$emit('record-program-data', this.sessionProgram, dataObj);
    },

    onUpdateIntervalTimer(duration, timerOffsetTimestampDate = null) {
      const timerOffsetTimestamp = (timerOffsetTimestampDate !== null)
        ? Timestamp.fromDate(timerOffsetTimestampDate)
        : null;
      const dataObj = {
        duration,
        timerOffsetTimestamp,
      };
      this.$emit('record-program-data', this.sessionProgram, dataObj);
    }, // onUpdateIntervalTimer()

    onPauseIntervalTimer(duration) {
      if (this.disable) {
        return;
      }

      const dataObj = {
        duration,
        timerOffsetTimestamp: null,
        isTimerPaused: true,
      };

      this.$emit('record-program-data', this.sessionProgram, dataObj);
    },

    onResumeIntervalTimer(duration) {
      const dataObj = {
        duration,
        timerOffsetTimestamp: Timestamp.now(),
        isTimerPaused: false,
      };

      this.$emit('record-program-data', this.sessionProgram, dataObj);
    },

  },
};
</script>
